export function fromTimestampedResourceToResource(timestampedResource) {
    const { timestamp, ...rest } = timestampedResource;
    void timestamp;
    return rest;
}
export function fromTimestampedResourcesToResources(timestampedResources) {
    return timestampedResources.map(fromTimestampedResourceToResource);
}
export function fromTimestampedResourcesByTypeToResourcesByType(timestampedResourcesByType) {
    const out = {};
    for (const [resourceTypeHandle, timestampedResources] of Object.entries(timestampedResourcesByType)) {
        out[resourceTypeHandle] = fromTimestampedResourcesToResources(timestampedResources ?? []);
    }
    return out;
}
export function extractProjectionMapByHandle(resources) {
    const map = new Map();
    for (const resource of resources ?? []) {
        const projection = resource.projection;
        if (!projection || typeof projection !== 'object' || !projection.handle) {
            continue;
        }
        map.set(projection.handle, projection);
    }
    return map;
}
export function extractProjectionHandleFromCarrier(projectionHandleCarrier) {
    return projectionHandleCarrier.projection.handle;
}
